export const actionTypes = {
  SAVE_SEGMENTED_ONBOARDING_STEP: 'SEGMENTED_ONBOARDING/SAVE_STEP',
};

export const saveSegmentedOnboardingStep = (data, step) => ({
  type: actionTypes.SAVE_SEGMENTED_ONBOARDING_STEP,
  payload: { step, data },
});
